<template>
	<div :class="`menu_sec ${isAddBackgroudToNav && 'nav-background'}`">
		<div v-if="!isMobile" class="desktop_menu">
			<div class="container-box">
				<nav class="navbar">
					<a class="navbar-brand" href="/"
						><img :src="img.image1" alt="Logo"
					/></a>

					<ul class="nav-list">
						<li class="nav-item dropdown">
							<a
								class="nav-link dropdown-toggle active"
								href="#"
								id="navbarDropdown"
								role="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								{{
									$t(
										'new_ui.components.header_component.navigation.individual.label',
									)
								}}
							</a>
							<ul class="dropdown-menu" aria-labelledby="navbarDropdown">
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/online_shopping',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.online_shopping',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/offline_kiosk',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.offline_kiosk',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/qr',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.pay_with_qr',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/jpworldpay_creditcard',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.jpworldpay_creditcard',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/trade_and_cashback',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.transaction_cashback',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/send',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.send_asset',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/receive',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.asset_request',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/deposit',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.get_deposit',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/commission',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.fee',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/wallet',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.wallet',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/account',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.account',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/jpys',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.jpys',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/sale',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.sell',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/exchange',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.exchanging_currency',
											)
										}}</a
									>
								</li>
							</ul>
						</li>
						<li class="nav-item dropdown">
							<a
								class="nav-link dropdown-toggle"
								href="#"
								id="navbarDropdown"
								role="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								{{
									$t(
										'new_ui.components.header_component.navigation.business.label',
									)
								}}
							</a>
							<ul class="dropdown-menu" aria-labelledby="navbarDropdown">
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/start',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.getting_Started',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/receive',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.accepting_payment',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/pay',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.make_a_payment',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/risk',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.risk_management',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/corps',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.about_company',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/platform',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.platforms_features',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/pay',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.payment_method',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/global',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.global_payment',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/pay',
											})
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.business.menu_items.processing',
											)
										}}</a
									>
								</li>
							</ul>
						</li>

						<li>
							<a
								class="dropdown-item"
								href="javascript:void(0)"
								v-on:click="
									$router.push({
										path: '/development/main',
									})
								"
								>{{
									$t(
										'new_ui.components.header_component.navigation.development.label',
									)
								}}</a
							>
						</li>

						<li class="nav-item">
							<a
								class="nav-link"
								:href="$router.resolve({ name: 'cs' }).href"
								>{{
									$t(
										'new_ui.components.header_component.navigation.customer_service.label',
									)
								}}</a
							>
						</li>
					</ul>
				</nav>
				<div class="head_btn_sec">
					<div class="language_sec">
						<div class="language-selector">
							<a
								class="nav-link dropdown-toggle btn_head active"
								href="#"
								id="languageDropdown"
								role="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<img
									:src="getCurrentLanguage.icon"
									:alt="getCurrentLanguage.name"
								/>
								{{ getCurrentLanguage.name }}
							</a>
							<ul class="dropdown-menu" aria-labelledby="languageDropdown">
								<li
									v-for="item in locales"
									:key="item.code"
									@click="s_locale_code = item.code"
									:class="{ active: s_locale_code === item.code }"
								>
									<img :src="getLanguageIcon(item.code)" :alt="item.name" />
									{{ item.name }}
								</li>
							</ul>
						</div>
					</div>
					<a
						class="btn_head"
						@click="handleLoginClick"
						href="javascript:void(0)"
						>{{ $t('new_ui.components.header_component.auth.login') }}</a
					>
					<a
						:href="$router.resolve({ name: 'auth-register' }).href"
						class="btn_head back_on"
						>{{ $t('new_ui.components.header_component.auth.signup') }}</a
					>
				</div>
			</div>
		</div>

		<div v-if="isMobile" class="mobile_menu header_m">
			<!-- 헤더 상단 (항상 보임) -->
			<div class="header_top">
				<div class="mobile_logo_area">
					<a href="/"><img :src="img.image1" alt="Logo" /></a>
				</div>

				<div class="d_flex align_items_center">
					<a class="mobile_menu_icon" @click="changeMobileNavOpen">
						<img v-if="!isMobileNavOpen" :src="menuIcon.open" alt="" />
					</a>
				</div>
			</div>

			<!-- 메뉴 오버레이 -->
			<div
				v-if="isMobileNavOpen"
				class="menu-overlay"
				@click="changeMobileNavOpen"
			></div>

			<!-- 사이드 메뉴 -->
			<div :class="[{ is_open: isMobileNavOpen }, 'header_wrap']">
				<div class="scroll_y">
					<div class="d_flex align_items_center justify_between p_20">
						<div class="language_sec">
							<div class="language-selector">
								<a
									class="nav-link dropdown-toggle btn_head active"
									href="#"
									id="languageDropdownMobile"
									role="button"
									data-bs-toggle="dropdown"
									aria-expanded="false"
								>
									<img
										:src="getCurrentLanguage.icon"
										:alt="getCurrentLanguage.name"
									/>
									{{ getCurrentLanguage.name }}
								</a>
								<ul
									class="dropdown-menu"
									aria-labelledby="languageDropdownMobile"
								>
									<li
										v-for="item in locales"
										:key="item.code"
										@click="s_locale_code = item.code"
										:class="{ active: s_locale_code === item.code }"
									>
										<img :src="getLanguageIcon(item.code)" :alt="item.name" />
										{{ item.name }}
									</li>
								</ul>
							</div>
						</div>
						<a @click="changeMobileNavOpen">
							<img
								:src="menuIcon.close"
								alt=""
								style="width: 30px; height: 30px"
							/>
						</a>
					</div>

					<div class="login_area">
						<div v-if="!is_logged_in" class="before_login">
							<p class="mb_20">
								{{ $t('menu.login_text1') }}<br />{{ $t('menu.login_text2') }}
							</p>
							<div class="before_login_btn">
								<a
									@click="handleLoginClick"
									href="javascript:void(0)"
									class="button_primary"
								>
									Login
								</a>
								<a
									:href="$router.resolve({ name: 'auth-register' }).href"
									class="button_bg_blue"
								>
									Sign up
								</a>
							</div>
						</div>

						<div v-else class="after_login">
							<div class="d_flex user_box">
								<div class="user_photo">
									<a>
										<img
											src="@/assets/images/v2/icon/account_circle.png"
											alt="user image"
										/>
									</a>
								</div>
								<div class="user_detail">
									<div class="d_flex align_items_center">
										<p class="user_name mr_5">
											{{ $store.state.auth.member_info.user_name }}
										</p>
									</div>
									<p class="access_date">
										{{
											$dayjs($store.state.auth.member_info.last_login).format(
												'YYYY.MM.DD HH:mm:ss',
											)
										}}
									</p>
								</div>
								<a @click.prevent="logoutHandler" class="btn_logout"
									><img :src="iconLogoutWhite" alt="logout icon"
								/></a>
							</div>
							<div class="user_menu d_flex justify_between mt_20">
								<div class="user_menu_item">
									<span class="icon SETTINGS"></span>
									<a @click="toRoute({ name: 'mypage-account' })">{{
										$t('menu.mypage-account')
									}}</a>
								</div>
								<div class="user_menu_item">
									<span class="icon CONFIRM"></span
									><a @click="toRoute({ name: 'mypage-certification' })">{{
										$t('menu.mypage-certification')
									}}</a>
								</div>
							</div>
						</div>
					</div>

					<!-- 개인 메뉴 -->
					<accordion>
						<accordion-item>
							<template v-slot:accordion-trigger>
								<p class="depth_1st">
									{{
										$t(
											'new_ui.components.header_component.navigation.individual.label',
										)
									}}
								</p>
								<span class="accordion_trigger_icon"></span>
							</template>
							<template v-slot:accordion-content>
								<li class="menu_item">
									<a
										@click="navigateToRoute('/personal/how/online_shopping')"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.online_shopping',
											)
										}}</a
									>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/how/offline_kiosk')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.offline_kiosk',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/how/qr')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.pay_with_qr',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a
										@click="
											navigateToRoute('/personal/how/jpworldpay_creditcard')
										"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.jpworldpay_creditcard',
											)
										}}</a
									>
								</li>
								<li class="menu_item">
									<a
										@click="navigateToRoute('/personal/how/trade_and_cashback')"
										>{{
											$t(
												'new_ui.components.header_component.navigation.individual.menu_items.transaction_cashback',
											)
										}}</a
									>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/request/send')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.send_asset',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/request/receive')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.asset_request',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/request/deposit')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.get_deposit',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/request/commission')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.fee',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/asset/wallet')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.wallet',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/asset/account')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.account',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/asset/jpys')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.jpys',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/asset/sale')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.sell',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/personal/asset/exchange')">{{
										$t(
											'new_ui.components.header_component.navigation.individual.menu_items.exchanging_currency',
										)
									}}</a>
								</li>
							</template>
						</accordion-item>
					</accordion>

					<!-- 비즈니스 메뉴 -->
					<accordion>
						<accordion-item>
							<template v-slot:accordion-trigger>
								<p class="depth_1st">
									{{
										$t(
											'new_ui.components.header_component.navigation.business.label',
										)
									}}
								</p>
								<span class="accordion_trigger_icon"></span>
							</template>
							<template v-slot:accordion-content>
								<li class="menu_item">
									<a @click="navigateToRoute('/business/how/start')">{{
										$t(
											'new_ui.components.header_component.navigation.business.menu_items.getting_Started',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/business/how/receive')">{{
										$t(
											'new_ui.components.header_component.navigation.business.menu_items.accepting_payment',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/business/how/pay')">{{
										$t(
											'new_ui.components.header_component.navigation.business.menu_items.make_a_payment',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/business/how/risk')">{{
										$t(
											'new_ui.components.header_component.navigation.business.menu_items.risk_management',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/business/operation/corps')">{{
										$t(
											'new_ui.components.header_component.navigation.business.menu_items.about_company',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/business/operation/platform')">{{
										$t(
											'new_ui.components.header_component.navigation.business.menu_items.platforms_features',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/business/operation/pay')">{{
										$t(
											'new_ui.components.header_component.navigation.business.menu_items.payment_method',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/business/operation/global')">{{
										$t(
											'new_ui.components.header_component.navigation.business.menu_items.global_payment',
										)
									}}</a>
								</li>
								<li class="menu_item">
									<a @click="navigateToRoute('/business/pay')">{{
										$t(
											'new_ui.components.header_component.navigation.business.menu_items.processing',
										)
									}}</a>
								</li>
							</template>
						</accordion-item>
					</accordion>

					<!-- 개발 메뉴 -->
					<div class="menu_1st">
						<a @click="navigateToRoute('/development/main')">{{
							$t(
								'new_ui.components.header_component.navigation.development.label',
							)
						}}</a>
					</div>

					<!-- 고객센터 메뉴 -->
					<div class="menu_1st">
						<a class="nav-link" :href="$router.resolve({ name: 'cs' }).href">{{
							$t(
								'new_ui.components.header_component.navigation.customer_service.label',
							)
						}}</a>
					</div>
				</div>

				<!-- 하단 배너 -->
				<div
					class="d_flex align_items_center justify_center w100"
					style="height: 95px"
				>
					<img
						src="@/assets/images/v2/banner-m-menu.png"
						alt=""
						style="width: auto; height: 100%"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';
import img from '@/assets/images/v2/logo.svg';
import lang from '@/assets/images/sub/Language.png';
import moblang from '@/assets/images/sub/mob_lang.png';
import colormoblang from '@/assets/images/sub/colormob_lang.png';
import iconEn from '@/assets/images/v2/icon/icon-en.svg';
import iconKo from '@/assets/images/v2/icon/icon-ko.svg';
import iconJa from '@/assets/images/v2/icon/icon-ja.svg';
import Accordion from '@/components/Layout/Accordion';
import AccordionItem from '@/components/Layout/AccordionItem';
import '@/assets/css/header.m.css';

export default {
	components: {
		Accordion,
		AccordionItem,
	},
	data: () => {
		return {
			mobile: window.innerWidth <= 768,
			img: {
				image1: img,
				image2: lang,
				image3: moblang,
				image4: colormoblang,
				iconEn: iconEn,
				iconKo: iconKo,
				iconJa: iconJa,
			},
			menuIcon: {
				open: require('@/assets/images/v2/icon/mobile_menu.svg'),
				close: require('@/assets/images/icon/mobile_menu_close.png'),
			},
			isMobileNavOpen: false,
			isBusinessOpen: false,
			isIndividualOpen: false,
			isAddBackgroudToNav: false,
		};
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
		window.removeEventListener('scroll', this.handleScroll);
	},
	watch: {
		isMobileNavOpen(value) {
			if (value) {
				document.body.classList.add('menu_open');
			} else {
				document.body.classList.remove('menu_open');
			}
		},
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		changeMobileNavOpen() {
			this.isMobileNavOpen = !this.isMobileNavOpen;
		},
		handleLoginClick() {
			if (this.is_logged_in) {
				// 이미 로그인된 상태라면 대시보드로 새로고침하면서 이동
				location.href = this.$router.resolve({
					name: 'wallet_account-assets',
				}).href;
			} else {
				// 로그인되지 않은 상태라면 로그인 페이지로 이동
				location.href = this.$router.resolve({ name: 'auth-login' }).href;
			}
		},
		navigateToRoute(path) {
			this.isMobileNavOpen = false;
			if (typeof path === 'string') {
				this.$router.push(path);
			} else {
				window.location.href = path;
			}
		},
		toggleBusinessSubmenu() {
			this.isBusinessOpen = !this.isBusinessOpen;
		},
		toggleIndividualSubmenu() {
			this.isIndividualOpen = !this.isIndividualOpen;
		},
		handleScroll() {
			if (window.scrollY > 120) {
				this.isAddBackgroudToNav = true;
			} else {
				this.isAddBackgroudToNav = false;
			}
		},
		getLanguageIcon(code) {
			const { iconEn, iconKo, iconJa } = this.img;

			switch (code) {
				case 'ko-KR':
					return iconKo;
				case 'ja-JP':
					return iconJa;
				case 'en-US':
				default:
					return iconEn;
			}
		},
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
		// language
		...mapState('common', ['locales']),
		...mapGetters('auth', ['is_logged_in']),
		s_locale_code: {
			get() {
				return this.$store.state.common.locale;
			},
			set(value) {
				this.$store.dispatch('common/setLocale', value);
			},
		},
		getCurrentLanguage() {
			const currentLocale = this.locales.find(
				locale => locale.code === this.s_locale_code,
			);
			const { iconEn, iconKo, iconJa } = this.img;

			if (!currentLocale) {
				return {
					name: 'English',
					icon: iconEn,
				};
			}

			let icon;
			switch (currentLocale.code) {
				case 'ko-KR':
					icon = iconKo;
					break;
				case 'ja-JP':
					icon = iconJa;
					break;
				case 'en-US':
				default:
					icon = iconEn;
					break;
			}

			return {
				name: currentLocale.name,
				icon: icon,
			};
		},
	},
};
</script>
